import React from 'react';
import { PropTypes } from 'prop-types';
import originalSymbol from '../../images/OriginalSymbol.png';
import printSymbol from '../../images/PrintSymbol.png';
import cardSymbol from '../../images/CardSymbol.png';

const GalleryThumb = (props) => {
    return (
        <div className="artwork-thumb col-12 col-sm-6 col-md-4 col-xl-3">
            <div className="inner position-relative">
                {(props.availableAsOriginal || props.availableAsPrint || props.availableAsCard) &&
                    <label className="availability">
                        {props.availableAsOriginal &&
                            <span data-toggle="tooltip" data-placement="top" title="Original available">
                                <img src={originalSymbol} />
                            </span>
                        }
                        {props.availableAsPrint &&
                            <span data-toggle="tooltip" data-placement="top" title="Prints available">
                                <img src={printSymbol} />
                            </span>
                        }
                        {props.availableAsCard &&
                            <span data-toggle="tooltip" data-placement="top" title="Cards available">
                                <img src={cardSymbol} />
                            </span>
                        }
                    </label>
                }
                <img className="img-fluid" src={props.imageUrl} title={props.name} />
                <label className="name">{props.name}</label>
            </div>
        </div>
    );
};

GalleryThumb.propTypes = {
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    availableAsOriginal: PropTypes.bool,
    availableAsPrint: PropTypes.bool,
    availableAsCard: PropTypes.bool
};

export default GalleryThumb;



// WEBPACK FOOTER //
// ./src/components/gallery/GalleryThumb.js